// Step1

import React, { Fragment, useEffect, useState } from 'react';
import { BookingStep1 } from 'core/redux/features/booking/types';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'core/redux/reducers';
import { selectActiveProduct } from 'core/redux/features/products/reducers/products';
import { actions } from 'core/redux/features/booking';
import classNames from 'classnames';
import { TimeUtil } from 'core/utils/date';
import { IFilterOption } from '../../../core/redux/features/shared/types';
import FormStepContainer from '../Components/FormStepContainer';
import { Column } from 'Components/Elements/Layouts';
import ProductMenu from '../Components/ProductMenu';
import {
  selectBookingMenus,
  selectBookingSeatFilterOption,
  selectBookingStepData,
} from 'core/redux/features/booking/reducers';
import ErrorMsg from '../Components/ErrorMsg';
import FormField from '../Components/FormField';
// import { hot } from 'react-hot-loader/root';
import Summary from '../Components/Summary';
import { useTrans } from 'core/hooks';
import { BOOKING_STEP1 } from 'core/redux/features/booking/constants';
import ProductMenuLoading from '../Components/ProductMenuLoading';
import { IProductAvailableTime } from 'core/redux/features/products/types';
import ButtonSelectDropdown from 'Components/Elements/Buttons/ButtonSelectDropdown';

interface IOwnProps {
  onHideMenuModal: () => void;
}

const useDropdownToggleControl = (defaultValues: {
  [key: string]: boolean;
}) => {
  const [dropdowns, setOpenDropdown] = useState<typeof defaultValues>(
    defaultValues,
  );

  return {
    dropdowns,
    isDropdownOpen: id => dropdowns[id],
    openDropdown: (id, toggle) =>
      setOpenDropdown({ ...dropdowns, [id]: toggle }),
  };
};

function Step1({ onHideMenuModal }: IOwnProps) {
  const dispatch = useDispatch();
  const trans = useTrans();
  const { product, loading, timeList, step } = useSelector(
    (state: AppState) => ({
      product: selectActiveProduct(state),
      // productMenus: state.products.entities.menus,
      loading: state.booking.loading,
      timeList: state.booking.times,
      step: selectBookingStepData(state, 0) as BookingStep1,
    }),
  );

  const productMenus = useSelector(selectBookingMenus);

  const productSeatOptions = useSelector(selectBookingSeatFilterOption);

  const onChangeNumPerson = (num: number) =>
    dispatch(actions.selectNumberOfPerson(num));

  const [timeObj, setTimeObj] = useState(null);

  const onChangeCartTime = (val: IProductAvailableTime) => {
    dispatch(actions.selectTime(val));
    setTimeObj(new TimeUtil(val.time));
  };

  useEffect(() => {
    if (step.data.time !== '0') {
      setTimeObj(new TimeUtil(step.data.time));
    }
    // eslint-disable-next-line
  }, [step.data.time]);

  useEffect(() => {
    dispatch(actions.setActiveStepIndex(BOOKING_STEP1));
  }, [dispatch]);

  const { dropdowns, isDropdownOpen, openDropdown } = useDropdownToggleControl({
    persons: false,
    time: false,
  });

  if (!product) {
    return null;
  }

  let selectedTimeLabel = '';
  if (step.data.time !== '0' && timeObj && timeObj.isValid()) {
    selectedTimeLabel += timeObj.format('HH.MM');
  }

  if (
    selectedTimeLabel &&
    product.product_type === 'bar' &&
    step.data.time_end
  ) {
    selectedTimeLabel +=
      ' - ' + TimeUtil.parse(step.data.time_end).format('HH.MM');
  }

  const timeOptions: IFilterOption[] = timeList?.result
    ?.filter(time => {
      const item = timeList.entities?.times[time];
      return item?.status === 'in-stock';
    })
    ?.map(time => {
      const item = timeList.entities.times[time];

      let timeLabel = TimeUtil.parse(item.time).format('HH.MM');

      let isAvailable = item.status === 'in-stock';

      if (item.time_end && product.product_type === 'bar') {
        timeLabel += ' - ' + TimeUtil.parse(item.time_end).format('HH.MM');
      }

      let seats = item.seat;
      if (!Array.isArray(item.seat)) {
        seats = Object.values(item.seat);
      }

      seats = seats.map(i => Number(i));

      let numPerson = step.data.num_person ? Number(step.data.num_person) : 0;
      if (numPerson > 0 && seats.indexOf(numPerson) === -1) {
        isAvailable = false;
      }

      const suffix = isAvailable
        ? trans('time_suffix')
        : `(${trans('time_not_possible')})`;

      return {
        id: item.time,
        label: `${timeLabel} ${suffix}`,
        disabled: !isAvailable,
      };
    });
  return (
    <FormStepContainer
      className="page-transition__content"
      id="book-step1"
      enableNextBtn={true}
    >
      <Column
        className="checkout__content__items checkout--right-border"
        size={['3-tablet']}
      >
        <div className="is-full">
          <FormField
            field="num_person"
            errors={step.errors}
            label={trans('how_many_are_you')}
          >
            <div
              onClick={e => {
                openDropdown('persons', !isDropdownOpen('persons'));
              }}
              className={classNames(
                'select select--haslabel is-fullwidth select--dropdown',
                loading && 'disabled',
                step.data.num_person < 1 && 'checkout__invalid',
              )}
            >
              <ButtonSelectDropdown
                hideInviSelect={true}
                defaultLabel={
                  step.data.num_person > 0
                    ? `${step.data.num_person} ${
                        step.data.num_person > 1
                          ? trans('persons')
                          : trans('person')
                      }`
                    : trans('select')
                }
                trans={trans}
                onSelect={(e, filter) => {
                  onChangeNumPerson(filter.id);
                  openDropdown('persons', !isDropdownOpen('persons'));
                }}
                selected={
                  (productSeatOptions.find(
                    item => item.id === step.data.num_person,
                  ) ?? { id: 0, label: '' }) as IFilterOption
                }
                options={
                  productSeatOptions.map(item => ({
                    id: item.id as any,
                    label: item.label,
                    disabled: item.disabled,
                  })) as Array<IFilterOption>
                }
                controlMobile={false}
                activeOnHover={false}
                isActive={dropdowns['persons']}
              />
              {/*<span className="select-label">*/}
              {/*  {step.data.num_person > 0*/}
              {/*    ? `${step.data.num_person} ${*/}
              {/*        step.data.num_person > 1*/}
              {/*          ? trans('persons')*/}
              {/*          : trans('person')*/}
              {/*      }`*/}
              {/*    : trans('select')}*/}
              {/*</span>*/}
              {/*<select*/}
              {/*  onChange={e => onChangeNumPerson(parseInt(e.target.value))}*/}
              {/*  value={step.data.num_person}*/}
              {/*  name="num_person"*/}
              {/*>*/}
              {/*  <option*/}
              {/*    style={{ display: 'none' }}*/}
              {/*    hidden={true}*/}
              {/*    key=""*/}
              {/*    value="0"*/}
              {/*  />*/}
              {/*  {productSeatOptions.map(item => (*/}
              {/*    <option*/}
              {/*      disabled={item.disabled}*/}
              {/*      value={item.id}*/}
              {/*      key={item.id}*/}
              {/*    >*/}
              {/*      {item.label}*/}
              {/*    </option>*/}
              {/*  ))}*/}
              {/*</select>*/}
            </div>
          </FormField>

          <FormField
            className={step.data.num_person > 0 ? '' : 'hide'}
            field="time"
            errors={step.errors}
            label={trans(`choose_time_${product.product_type}`)}
          >
            <div
              onClick={e => {
                openDropdown('time', !isDropdownOpen('time'));
              }}
              className={classNames(
                'select select--haslabel is-fullwidth select--dropdown',
                (timeList.result.length === 0 ||
                  step.data.num_person === 0 ||
                  loading) &&
                  'disabled',
                step.data.time === '0' && !loading && 'checkout__invalid',
              )}
            >
              <ButtonSelectDropdown
                hideInviSelect={true}
                defaultLabel={
                  selectedTimeLabel
                    ? `${selectedTimeLabel} ${trans('time_suffix')}`
                    : trans('select')
                }
                trans={trans}
                onSelect={(e, filter) => {
                  onChangeCartTime(timeList.entities.times[filter.id]);
                  openDropdown('time', false);
                }}
                selected={
                  (timeOptions.find(item => item.id === step.data.time) ?? {
                    id: 0,
                    label: '',
                  }) as IFilterOption
                }
                options={timeOptions}
                controlMobile={false}
                activeOnHover={false}
                isActive={dropdowns['time']}
              />
              {/*<span className="select-label">*/}
              {/*  {selectedTimeLabel*/}
              {/*    ? `${selectedTimeLabel} ${trans('time_suffix')}`*/}
              {/*    : trans('select')}*/}
              {/*</span>*/}

              {/*<select*/}
              {/*  name="time"*/}
              {/*  value={step.data.time}*/}
              {/*  onChange={e =>*/}
              {/*    onChangeCartTime(timeList.entities.times[e.target.value])*/}
              {/*  }*/}
              {/*>*/}
              {/*  <option*/}
              {/*    style={{ display: 'none' }}*/}
              {/*    hidden={true}*/}
              {/*    key=""*/}
              {/*    value="0"*/}
              {/*  />*/}
              {/*  {timeList.result.length > 0*/}
              {/*    ? timeList.result*/}
              {/*        // .filter(*/}
              {/*        //   time =>*/}
              {/*        //     timeList.entities.times[time].status === 'in-stock',*/}
              {/*        // )*/}
              {/*        .map(time => {*/}
              {/*          const item = timeList.entities.times[time];*/}

              {/*          let timeLabel = TimeUtil.parse(item.time).format(*/}
              {/*            'HH.MM',*/}
              {/*          );*/}

              {/*          const isAvailable = item.status === 'in-stock';*/}

              {/*          if (item.time_end && product.product_type === 'bar') {*/}
              {/*            timeLabel +=*/}
              {/*              ' - ' +*/}
              {/*              TimeUtil.parse(item.time_end).format('HH.MM');*/}
              {/*          }*/}

              {/*          return (*/}
              {/*            <option*/}
              {/*              value={item.time}*/}
              {/*              key={item.time}*/}
              {/*              disabled={!isAvailable}*/}
              {/*            >*/}
              {/*              {timeLabel}{' '}*/}
              {/*              {isAvailable*/}
              {/*                ? trans('time_suffix')*/}
              {/*                : `(${trans('time_not_possible')})`}*/}
              {/*            </option>*/}
              {/*          );*/}
              {/*        })*/}
              {/*    : null}*/}
              {/*</select>*/}
            </div>
          </FormField>
        </div>
      </Column>
      <Column className="checkout__content__items checkout__menus">
        <div
          className={classNames(
            step.data.time === '0' && 'hide',
            Object.values(step.data.menus).length === 0 &&
              !loading &&
              'checkout__invalid',
          )}
        >
          <label className="label">
            {trans('choose_menu', { num: step.data.num_person.toString() })}
          </label>
          <span onClick={onHideMenuModal} className="book-menu__view">
            {trans('view_menu')}
          </span>
          {!productMenus ? (
            <>
              <ProductMenuLoading />
              <ProductMenuLoading />
              <ProductMenuLoading />
            </>
          ) : (
            Object.entries(productMenus).map(([menuId, menus], arrIndex) => {
              if (!menus || menus.status !== 'in-stock') {
                return null;
              }

              return (
                <Fragment key={menuId}>
                  <ProductMenu
                    status={menus.status}
                    onHideMenuModal={onHideMenuModal}
                    menu={menus}
                  />
                  {arrIndex !== product.menus.length - 1 ? <hr /> : null}
                </Fragment>
              );
            })
          )}
          <div className="spacer" />
          <ErrorMsg field="menus" errors={step.errors} />
        </div>
      </Column>

      <Column
        className="checkout__content__summary checkout__content__items checkout--bg-blue"
        size={'4'}
      >
        <Summary />
      </Column>
    </FormStepContainer>
  );
}

export default Step1;
